import script from "./NotificationsBrowser.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsBrowser.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsBrowser.vue?vue&type=style&index=0&id=5b50a2bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b50a2bc"]])

export default __exports__